import React, { useEffect, useImperativeHandle, useRef, useState } from 'react'
import { OptionModel } from '../../../common/types/OptionModel'
import PaymentLinkResultModal from '../PaymentLinkResultModal'
import Modal from '../Modal'
import { Button } from '../Elements'
import { ApiResponseType } from '../../../common/api/apiHelper'
import commonNetwork from '../../../common/api/commonNetwork'
import { toast } from 'react-toastify'
import { Form, Formik } from 'formik'
import FormObserver from '../FormElements/FormObserver'
import { FormInput } from '../FormElements'
import { updateOrderErpCustomerModelSchema } from '../../../common/validators/updateOrderErpCustomerModelSchema'
import { useDispatch } from 'react-redux'
import { clearErpIntegrationCustomer } from '../../../store/slices/erpIntegrationCustomerSlice'
import { getIntegrationList } from '../../../store/slices/IntegrationSlice'
import { ThunkDispatch } from 'redux-thunk'

type componentProps = {
    onUpdateOrderErpCustomerParameter: Function
}

const initialOptions: OptionModel[] = [{
    value: 0,
    label: ""
}];

const initialValues = {
    customerCode: "",
    taxCode: "",
    responseCustomerCode: "",
    responseCustomerName: "",
    orderId: 0
}

const UpdateOrderErpCustomerModal = React.forwardRef((props: componentProps, ref) => {

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const linResultModalRef = useRef<any>();

    const [createLoading, setCreateLoading] = useState<boolean>(false);
    const [statusModalVisible, setStatusModalVisible] = useState<boolean>(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [formValues, setFormValues] = useState(initialValues);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const [showSubmitButton, setShowSubmitButton] = useState<boolean>(false);

    useImperativeHandle(ref, () => ({

        openModal(defaultValues: any) {
            setFormValues(() => ({
                customerCode: "",
                taxCode: "",
                responseCustomerCode: "",
                responseCustomerName: "",
                orderId: defaultValues.orderid
            }));
            setIsModalVisible(true);
            setCreateLoading(false);
        }
    }));

    const onSubmit = async () => {
        try {
            setSearchLoading(true);
            const parameters = {
                customerCode: formValues.customerCode,
                taxCode: formValues.taxCode
            }

            let result: ApiResponseType;
            result = await commonNetwork.get("/integration/get-erp-customer", parameters);
            if (result.isSuccess) {
                setFormValues(prevValues => ({
                    ...prevValues,
                    responseCustomerCode: result.data.customerCode,
                    responseCustomerName: result.data.customerName
                }))
                setShowSubmitButton(true);
            } else {
                toast.error("Müşteri Bulunamadı : " + result.errorMessage);
            }
        } catch (error) {

        } finally {
            setSearchLoading(false);
        }
    }

    const updateCustomerCode = async () => {
        try {
            if (
                (!formValues.customerCode || formValues.customerCode.trim() === "") &&
                (!formValues.taxCode || formValues.taxCode.trim() === "")
            ) {
                toast.error("Cari Hesap Kodu ve VKN alanlarını boş bırakamazsınız.");
            } else {
                var params = {
                    customerCode: formValues.responseCustomerCode,
                    customerName: formValues.responseCustomerName,
                    orderId: formValues.orderId
                }
                const { isSuccess, data, errorMessage } = await commonNetwork.post("/integration/UpdateCustomerCodeAtOrder/", params);
                if (isSuccess) {
                    const parameters = {
                        timeStart: "",
                        timeEnd: "",
                        paymentProvider: "",
                        isSync: false,
                        customerCode: ""
                    };
                    dispatch(clearErpIntegrationCustomer())
                    setTimeout(() => {
                        dispatch(getIntegrationList({ parameters }));
                    }, 550);
                }
                setIsModalVisible(false);
            }
        } catch (error) {

        } finally {
            setShowSubmitButton(false);
        }
    }

    const onUpdate = (value: any) => {
        setFormValues(prevValues => ({
            ...prevValues,
            customerCode: value.customerCode,
            taxCode: value.taxCode
        }));
    };

    return (
        <div>
            <PaymentLinkResultModal ref={linResultModalRef} statusModalVisible={statusModalVisible} setStatusModalVisible={setStatusModalVisible}></PaymentLinkResultModal>
            <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
                <div>
                    <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%]">
                            <h3 className="text-md leading-6 font-medium text-gray-900">
                                Cari Hesap Parametresini Sorgula
                            </h3>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={updateOrderErpCustomerModelSchema}
                                enableReinitialize
                                onSubmit={onSubmit}
                            >
                                {({ }) => {
                                    return (<Form>
                                        <FormObserver watch={(val: any) => onUpdate(val)} />
                                        <div className="flex w-100">
                                            <div className="flex-auto w-50">
                                                <div className='mt-4'>
                                                    <FormInput
                                                        label="Cari Hesap Kodu"
                                                        name="customerCode"
                                                        type="text"
                                                        maxLength={51}
                                                    />
                                                </div>
                                                <div className='mt-4'>
                                                    <FormInput
                                                        label="Vergi Numarası"
                                                        name="taxCode"
                                                        type="text"
                                                        mask="99999999999"
                                                    />
                                                </div>
                                                <div className='mt-4'>
                                                    <Button
                                                        type="submit"
                                                        color="primary"
                                                        hover="primary"
                                                        size="xs"
                                                        loading={searchLoading}
                                                        disabled={searchLoading}
                                                    >
                                                        <img src="/icons/search-white.svg" alt="search" />
                                                        <span className='mx-2'>Ara</span>
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-5 mt-4 flex justify-end space-x-2">
                                            <Button
                                                color="gray"
                                                hover="gray"
                                                size="xs"
                                                callback={() => setIsModalVisible(false)}
                                            >
                                                Vazgeç
                                            </Button>
                                            {showSubmitButton ? <Button
                                                color="primary"
                                                hover="primary"
                                                size="xs"
                                                loading={createLoading}
                                                disabled={createLoading}
                                                callback={() => updateCustomerCode()}
                                            >
                                                Değiştir
                                            </Button> : null}
                                        </div>
                                    </Form>)
                                }}
                            </Formik>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
})

export default UpdateOrderErpCustomerModal;